import { createApi } from '@reduxjs/toolkit/query/react';

import { API_TAGS } from './tags';
import { baseQueryWithReauth } from './base-query-with-reauth';

// TODO: recheck refresh token logic when backend is ready
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(API_TAGS),
  endpoints: () => ({})
});
